import { REACT_APP_API_URL } from "../env";
//////////////////////////
////////////////////////////
//////////////////////////////
/////////////////////////////////

export const AUTH_SSO = `${REACT_APP_API_URL}auth/sso`;

export const AUTH_OTP = `${REACT_APP_API_URL}auth/otp`;
